module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('p', [_vm._v("Stanley Oliver is the pen name of a Christian author of poetry, short stories, and plays. "), _c('em', [_vm._v("Breath of God")]), _vm._v(" is his first published novel, which he describes as an uplifting comedy of relationships told through the eyes of Stanley, a Messianic private detective in Belfast, as he carries out his investigation into the disappearance of Steven Ford, in a sharp and witty tone, juxtaposed with several more serious and poignant moments that he thinks create a multi-faceted and captivating story. He is 18, with 85 years of experience and lives in Belfast.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ad60488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0